import { Component, OnInit, ViewChild } from "@angular/core";
import { paths } from "src/app/Shared/enums/paths.enum";
import { CommonService } from "src/app/Shared/services/common_services/common.service";
import { DataCommunicationService } from "src/app/Shared/services/data_service/data-communication.service";
import { LoaderindicatorService } from "src/app/Shared/services/loaderindicator/loaderindicator.service";
import { TranslateService } from "@ngx-translate/core";
import { PlatformLocation, formatDate } from "@angular/common";
import { ReadingJsonService } from "src/app/Shared/services/configuration_service/reading-json.service";
import { RentalCarListComponent } from "src/app/Shared/component/rental-car-list/rental-car-list.component";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { Input } from "@angular/core";
import { environment } from "src/environments/environment";
import { MinBilConsentModel } from "src/app/Shared/model/MinBilConsentModel";

declare var gtag;
@Component({
  selector: "app-confirm-booking",
  templateUrl: "./confirm-booking.component.html",
  styleUrls: ["./confirm-booking.component.css"],
})
export class ConfirmBookingComponent implements OnInit {
  @ViewChild(RentalCarListComponent) rentalCarListComponent: RentalCarListComponent;
  @Input() recall ='';
  
  privacyPolicyLink = environment.privacyPolicyLink
  maxNotesLength: number = environment.commentLength;
  splitHours: number = environment.SplitHours;
  count = 0;
  currentMonth: any;
  showRentalCar = false;
  Time: boolean;
  waitingCheck: boolean = false;
  rentalCheck: boolean = false;
  timePicker: boolean = true;
  searchParams: any;
  rentalCarList : any;
  rentalCarPrice = 0;
  rentalCar: any;
  currentDateMonth;
  ShowCar: boolean = false;
  DropedTime: boolean = false;
  rentalCarDate: any;
  Timeslote = [];
  selectedItem: any;
  selectedItems: any;
  dropTimeslote = [];
  code: string;
  CustomerWaitingSelected: boolean = true;
  datesDisabled;
  weekdends = [];
  pkkDate: any;

  weekendDaysList = [];
  IsSubmitted = true;
  model: NgbDateStruct;
  dealerName: string;
  currentDate = new Date();
  disabledDates: NgbDateStruct[] = [];
  brandName: string;
  CustomerWaitings: boolean = false;
  date: { year: number; month: number };
  innerMessage: string;
  dealerConfig;
  kiosk = false;
  IsCustomerWait = false;
  rentalYes: boolean = false;
  rentalNo: boolean = false;
  CustomerWaitingYes: boolean = false;
  CuatomerWaitingNo: boolean = false;
  BrandCode: any;
  customerVehicleList: any = [];
  PackageData: any;
  serviceList = [];
  euServiceData = [];
  serviceTotal = 0;
  vehicleKilometer = 0;
  totalSelectedRental: boolean = false;
  CustomerNotes: "";
  PDetail;
  currentData: any;
  SelectedDate: any;
  ModelImage: any;
  MthsFromRegistration: any;
  DateLastService: any;
  PickAtKiosk = false;
  PickUpCar = false;
  DeliverCar = false;
  serviceAgreement = false;
  PkkService = false;
  isWaiting  = false;
  selectedPickupOption = "";
  selectedDeliveryOption = "";
  services=[];
  optional=[];
  urgent=[];
  public scrollbarOptions = { axis: "yx", theme: "minimal-dark" };
  public availableTimeSlots: string[] = [];
  public selectedSlot: string
  disableButton: boolean=false;
  SelectedDealerName: string='';
  isServerLive: boolean = true;
  selectedAccessories: any;
  selectedGiftCards: any;
  selectedSplitSlot: [] = [];
  isMinBilUser: boolean = true;
  minBilConsent: MinBilConsentModel = new MinBilConsentModel();

  constructor(
    private commonService: CommonService,
    private loaderservice: LoaderindicatorService,
    private dataCommunicationService: DataCommunicationService,
    private translate: TranslateService,
    private readJsonFile: ReadingJsonService
  ) {
    const currentDate = new Date();
    this.dealerName = this.commonService.getLocalStorage("dealername");
    const twoDayLatter = new Date();
    twoDayLatter.setDate(twoDayLatter.getDate() + 3);
    this.rentalCarDate = {
      year: twoDayLatter.getFullYear(),
      month: Number(twoDayLatter.getMonth() + 1),
      day: Number(twoDayLatter.getDate()),
    };
  }

  public Slected(codeChecked: any, value: any) {
      this.code = codeChecked;
    // if (this.code === 'rentalCar' && this.dealerConfig.EnableRentalCar == true) {
    //   this.showRentalCar = true;

    // }
    if (this.code === "customerWaiting") {
      // this.CustomerWaitings = true;
      // this.CustomerWaitingSelected = false;
      // this.ShowCar = false;
      // this.showRentalCar = true;
      this.commonService.setLocalStorage('isWaiting','yes')
      //localStorage.removeItem("dropTime");
      //localStorage.removeItem("RentalCar");
    } else if (this.code === "DropTime" && value !=null) {
      this.ShowCar = true;
      this.showRentalCar = true;
      this.selectedItem = value;
      this.disableButton=false;
      localStorage.setItem("dropTime", value);
    } else if (this.code === "Waiting") {
      this.selectedItems = value;

      localStorage.setItem("waitingTime", value);
    } else if(value == null && this.code==="DropTime"){
      localStorage.removeItem("dropTime");
      this.selectedItem =null;
      this.disableButton=false;
      setTimeout(() => {
        this.commonService.getErrorMessage(
          "LoaderText.MechanicNotAvailable"
        );
      }, 1000);
      
    }
  }

  public notSlected(event: any) {
    this.code = event;
    // if (this.code === 'rentalCar') {
    //   this.showRentalCar = false;
    //   localStorage.removeItem('RentalCar');
    // }
    if (this.code === "customerWaiting") {
      // this.ShowCar = true;
      // this.CustomerWaitings = false;
      // this.CustomerWaitingSelected = !this.CustomerWaitingSelected;
      this.commonService.removeLocalStorage(['isWaiting','waitingTime'])
      // this.selectedItems = null;
      // this.selectedItem = null;
    }
  }
  public changeisWaiting(){
    this.isWaiting = true;
    this.PickAtKiosk = false;
    this.PickUpCar = false;
  }
  public changePickAtKiosk(){
    this.PickAtKiosk = true;
    this.isWaiting = false;
    this.PickUpCar = false;
  }
  public changePickUpCar(){
    this.PickUpCar = true;
    this.PickAtKiosk = false;
    this.isWaiting = false;
  }
  public changeKioks(){
    this.kiosk = true;
    this.DeliverCar = false;
  }
  public changeDeliverCar(){
    this.kiosk = false;
    this.DeliverCar = true;
  }
  public notesChange() {
    if (
      this.CustomerNotes !== undefined &&
      this.CustomerNotes !== "" &&
      this.CustomerNotes != null
    ) {
      this.commonService.setLocalStorage("notes", this.CustomerNotes);
    } else {
      this.commonService.removeLocalStorage(["notes"]);
    }
  }
  //  public storeTime($event){
  //    debugger
  //    localStorage.setItem('witingTime',$event.value);
  //  }

  public getTimeSlot() {
    this.Timeslote = [];
    this.Timeslote.push(
      {
        key: "09:00",
        description: "09:00",
        value: "09:00",
      },
      {
        key: "10:00",
        description: "10:00",
        value: "10:00",
      },
      {
        key: "12:00",
        description: "12:00",
        value: "12:00",
      }
    );
  }

  public getDropTimeSlot() {
    this.dropTimeslote = [];
    this.dropTimeslote.push(
      {
        key: "08:00",
        description: "08:00",
        value: "08:00",
      },
      {
        key: "08:30",
        description: "08:30",
        value: "08:30",
      },
      {
        key: "09:00",
        description: "09:00",
        value: "09:00",
      },
      {
        key: "09:30",
        description: "09:30",
        value: "09:30",
      },
      {
        key: "10:00",
        description: "10:00",
        value: "10:00",
      },
      {
        key: "10:15",
        description: "10:15",
        value: "10:15",
      }
    );
  }

  public confirmBooking() {
    if (this.rentalCar != null) {
      this.commonService.setLocalStorage("RentalCar", this.rentalCar);
    }
    // if (this.ThirdPartyRentalcar > 0 && this.showRentalCar) {
    //   this.translate.get('Common.CommonText.label.rentedcar').subscribe(message => {
    //     this.commonService.setLocalStorage('RentalCar', ({ "Brand": message, "Price": this.dealerConfig.RentalCarPrice }));
    //   });
    // }
    this.commonService.setLocalStorage("kiosk", this.kiosk);
    this.commonService.setLocalStorage("isWaiting", this.isWaiting);
    this.commonService.setLocalStorage("serviceAgreement", this.serviceAgreement);
    this.commonService.setLocalStorage("PickAtKiosk", this.PickAtKiosk);
    this.commonService.setLocalStorage("PickUpCar", this.PickUpCar);
    this.commonService.setLocalStorage("DeliverCar", this.DeliverCar);



    const appointmentFormData = {};

    var PackageServiceData = [];
    const serviceIDList = [];

    if (this.PackageData != null) {
      this.PDetail = [];
      if (this.PackageData.SelectedPackage.length > 0) {
        for (let g = 0; g < this.PackageData.SelectedPackage.length; g++) {
          PackageServiceData = [];
          for (
            let s = 0;
            s <
            this.PackageData.SelectedPackage[g].SelectedPackageServices.length;
            s++
          ) {
            const servicepackage = {
              ElementType:
                this.PackageData.SelectedPackage[g].SelectedPackageServices[s]
                  .ElementType,
              ServiceName:
                this.PackageData.SelectedPackage[g].SelectedPackageServices[s]
                  .ServiceName,
              Quantity:
                this.PackageData.SelectedPackage[g].SelectedPackageServices[s]
                  .Quantity,
              // Price: this.ServiceDetail[s].Price,
              // LineAmount: this.ServiceDetail[s].LineAmount,
              VM: this.PackageData.SelectedPackage[g].SelectedPackageServices[s]
                .VM,
              LineAmountVat:
                this.PackageData.SelectedPackage[g].SelectedPackageServices[s]
                  .LineAmountVat,
              Rebate:
                this.PackageData.SelectedPackage[g].SelectedPackageServices[s]
                  .LineAmountVat.Rebate,
              duration:
                this.PackageData.SelectedPackage[g].SelectedPackageServices[s]
                  .duration,
              ServiceId:
                this.PackageData.SelectedPackage[g].SelectedPackageServices[s]
                  .ServiceId,
            };
            PackageServiceData.push(servicepackage);
          }

          this.PDetail.push({
            ServiceName: this.PackageData.SelectedPackage[g].packageName,
            ServiceId: this.PackageData.SelectedPackage[g].PackageId,
            ServiceType: this.PackageData.SelectedPackage[g].PackageType,
            Duration: Number(
              this.commonService.getLocalStorageitem("totalTime")
            ), //this.PackageData.SelectedPackage[g].duration,
            ServiceTotal: this.PackageData.SelectedPackage[g].price,
            PartsTotal: this.PackageData.SelectedPackage[g].PartsTotal,
            WorkTotal: this.PackageData.SelectedPackage[g].WorkTotal,
            ApplicablePrice:
              this.PackageData.SelectedPackage[g].ApplicablePrice,
            TotalGrossPrice:
              this.PackageData.SelectedPackage[g].TotalGrossPrice,
            TotalRegularPrice:
              this.PackageData.SelectedPackage[g].TotalRegularPrice,
            Rebate: this.PackageData.SelectedPackage[g].Rebate,
            VM: this.PackageData.SelectedPackage[g].VM,
            ServicePackageDetail: PackageServiceData,
            //subPackageList:this.PackageData.SelectedPackage[g].subPackageList
          });
        }
      }
    }
    const appointmentDate = this.commonService.getLocalStorage("AppointDate");
    appointmentFormData["CustomerExternalViewModel"] =
      this.commonService.getLocalStorage("customerData");
    appointmentFormData["VehicleExternalViewModel"] =
      this.commonService.getLocalStorage("vehicleData");
    appointmentFormData["AddtionalServicePackageDetail"] = this.serviceList;
    console.log(this.serviceList)
    
    appointmentFormData["DelerId"] =
      this.commonService.getLocalStorage("dealername");
    appointmentFormData["AppoinmentBookDateTime"] =
      appointmentDate.month +
      "/" +
      appointmentDate.day +
      "/" +
      appointmentDate.year;
    
    appointmentFormData["Month"] = this.currentDate.getMonth() + 1;
    appointmentFormData["YearCalender"] = this.currentDate.getFullYear();

    let custNote = this.CustomerNotes ? this.CustomerNotes : '';
    let rf = this.commonService.getLocalStorageitem("RF");
    custNote += this.kiosk?' | Jeg ønsker på levere nøkkelen i kiosk/automat':'';
    custNote += this.DeliverCar?' | Jeg leverer bilen minimum 15 minutter før timen':'';
    custNote += this.PickAtKiosk?' | Jeg ønsker å hente bil på kiosk/automat døgnåpent':'';
    custNote += this.PickUpCar?' | Jeg henter bilen min innenfor åpningstiden':'';
    custNote += this.isWaiting? ' | Jeg ønsker å vente under service' : '';
    custNote += rf == 'yes' ? ' | Utestående produktforbedringskampanje' : '';
    appointmentFormData["CustomerNote"] = custNote;

    let customerNotes = [];
    if(this.CustomerNotes)
      customerNotes.push(this.CustomerNotes);
    if(this.kiosk)
      customerNotes.push('Jeg ønsker på levere nøkkelen i kiosk/automat');
    if(this.DeliverCar)
      customerNotes.push('Jeg leverer bilen minimum 15 minutter før timen');
    if(this.PickAtKiosk)
      customerNotes.push('Jeg ønsker å hente bil på kiosk/automat døgnåpent');
    if(this.PickUpCar)
      customerNotes.push('Jeg henter bilen min innenfor åpningstiden');
    if(this.isWaiting)
      customerNotes.push('Jeg ønsker å vente under service');
    if(rf == 'yes')
      customerNotes.push('Utestående produktforbedringskampanje');

    appointmentFormData["CustomerNotes"] = customerNotes;

    appointmentFormData["ServicePackageViewModel"] = this.PDetail;
    if(this.selectedAccessories != null && this.selectedAccessories != undefined){
      this.selectedAccessories.forEach(element => {
        delete element.isSelected;
        element.ImagePath = '';
      });
    }
    
    appointmentFormData["selectedAccessories"] = this.selectedAccessories;
    // appointmentFormData['IsForMaintenance'] = this.maintenance;
    // appointmentFormData['IsTiresHotel'] = this.HotelAtTyre;
    appointmentFormData["IsCustomerWaiting"] =
      this.commonService.getLocalStorageitem("waitingTime") != null
        ? true
        : false;
    appointmentFormData["WaitTime"] =
      this.commonService.getLocalStorageitem("waitingTime");
    appointmentFormData["DropTime"] =
      this.commonService.getLocalStorageitem("dropTime");
    let rentalcartemp = this.commonService.getLocalStorage("RentalCar");
    appointmentFormData["RentalCarDetailModel"] = rentalcartemp;
    appointmentFormData["RentalCarId"] = rentalcartemp != null ? rentalcartemp.RentalCarId : 0;
    appointmentFormData["RentalProvider"] = rentalcartemp == null ? 0 : this.commonService.getLocalStorageByKey( "dealerConfig", "RentalProvider" );
    appointmentFormData["IsOwnRentalCar"] = this.commonService.getLocalStorageByKey( "dealerConfig","RentalProvider") == 1? true: false;
    appointmentFormData["RentalCarPrice"] = rentalcartemp != null ?  rentalcartemp.Price : 0;
    //appointmentFormData["ThirdPartyRentalCarCost"] = this.commonService.getLocalStorageByKey("dealerConfig", "RentalCarPrice");
    // appointmentFormData['AppointmentJobPlanningViewModel'] = this.appointmentJobPlanning;
    appointmentFormData["Kiosk"] =
      this.commonService.getLocalStorageitem("kiosk");
    appointmentFormData["TotalKM"] =
      this.commonService.getLocalStorageitem("VehileKm") == "---"
        ? 0
        : this.commonService.getLocalStorageitem("VehileKm");
    appointmentFormData["IsOnlineWidget"] = true;
    

    

          appointmentFormData["TotalServicesHours"] =
          this.commonService.getLocalStorageitem("totalTime");
    appointmentFormData["RecallFactory"] =
      this.commonService.getLocalStorageitem("RF");
    appointmentFormData["IsElectric"] =
      this.commonService.getLocalStorageByKey("vehicleData", "Fuelcode") ==
      "Electric"
        ? true
        : false;
    appointmentFormData["EuControlServiceDetail"] = this.euServiceData;
    appointmentFormData["PickAtKiosk"] =
      this.commonService.getLocalStorageitem("PickAtKiosk");
    //appointmentFormData["PickUpCar"] =
      //this.commonService.getLocalStorageitem("PickUpCar");
    //appointmentFormData["DeliverCar"] =
      //this.commonService.getLocalStorageitem("DeliverCar");
    appointmentFormData["ServiceAgreement"] = this.serviceAgreement;
    appointmentFormData["AppointmentSource"] = this.commonService.getLocalStorageitem("AppointmentSource");
    appointmentFormData["SelectedGiftCards"] = null;
    if(this.selectedGiftCards != undefined){
      appointmentFormData["SelectedGiftCards"] = this.selectedGiftCards;
    }
    appointmentFormData["SelectedSplitSlot"] = this.selectedSplitSlot;
    //console.log(JSON.stringify(appointmentFormData))
    this.translate.get("LoaderText.loading").subscribe((message) => {
      this.loaderservice.show(message);
    });
    // if(this.selectedSlot!='' && this.selectedSlot!=undefined && this.selectedSlot!=null)
    // {
    //   appointmentFormData["IsCustomerWaiting"] =false
    // appointmentFormData["WaitTime"] =null
    // appointmentFormData["DropTime"] =this.selectedSlot
    // this.commonService.removeLocalStorage(['dropTime','waitingTime']);
    // this.commonService.setLocalStorage('dropTime',this.selectedSlot)
    // }
    appointmentFormData["RepairComment"]=this.commonService.getLocalStorageitem("RepairComment");
    this.dataCommunicationService
      .saveBookingOrder(appointmentFormData)
      .subscribe(
        (result) => {
          this.disableButton=false;
          this.loaderservice.hide();
          if (result.StatusCode === 1) {
            this.evaluateDataForAnalytics();
            this.commonService.NavigatePage(paths.BOOKINGSUMMARY);
          } else {
          }
        },
        (error) => {
          this.commonService.getErrorMessage("LoaderText.WentWrong");
        }
      );
  }
  public evaluateDataForAnalytics() {
    let IsNotes = "false";
    let IsRentalCar = "true";
    if (this.commonService.getLocalStorageitem("notes") != null) {
      IsNotes = "true";
    }
    if ( this.commonService.getLocalStorageByKey("RentalCar", "RentalCarId") == null || this.commonService.getLocalStorageByKey("RentalCar", "RentalCarId") == "0"
    ) {
      IsRentalCar = "false";
    }
    if (IsRentalCar === "true") {
      this.PushDataToAnalytics(
        this.commonService.getLocalStorageByKey("vehicleData", "BrandName") +
          " " +
          this.commonService.getLocalStorageByKey("vehicleData", "ModelName"),
        IsRentalCar,
        IsNotes,
        this.serviceTotal +
          this.commonService.getLocalStorageByKey("RentalCar", "Price")
      );
    } else {
      this.PushDataToAnalytics(
        this.commonService.getLocalStorageByKey("vehicleData", "BrandName") +
          " " +
          this.commonService.getLocalStorageByKey("vehicleData", "ModelName"),
        IsRentalCar,
        IsNotes,
        this.serviceTotal
      );
    }
  }
  public PushDataToAnalytics(BrandModel, RentalCar, Notes, TotalSum) {
    this.currentData = {
      "so-car": BrandModel, // make and model of the car
      "so-dealer": this.SelectedDealerName, // name of the dealer
      "so-dealerMessage": Notes, // 'true'/'false' based on if the user have submitted a custom message to the dealer
      "so-rentalCar": RentalCar, // 'true'/'false' based on if the user have selected to rent a car
      "so-orderValue": TotalSum, // total sum of the order including all services and renalt car
    };
    //(window as any).dataLayer.push(this.currentData);

    gtag('event', 'BookingRecieved', this.currentData);
  }

  toggleShow() {
    // this.isShown = ! this.isShown;
    const MitsubishiParentClass = document.querySelector("#confirmPage");
    if (MitsubishiParentClass.classList.contains("os-open")) {
      MitsubishiParentClass.classList.remove("os-open");
    } else {
      MitsubishiParentClass.classList.add("os-open");
    }
  }
  public ServiceListPage() {
    this.commonService.NavigatePage(paths.CARSERVICE);
  }

  public dateChanged($event) {
    this.IsSubmitted = false;
    if ($event != null && $event != undefined) {
      this.SelectedDate = $event.day + "." + $event.month + "." + $event.year;
      this.rentalCarDate = {
        year: $event.year,
        month: $event.month,
        day: $event.day,
      };
      this.commonService.setLocalStorage("AppointDate", $event);
      //console.log(this.rentalCarDate);
      // if (this.rentalCarListComponent != undefined)
      //   this.rentalCarListComponent.getRentalCars(this.rentalCarDate);
       this.IsSubmitted = false;
    } else {
      this.IsSubmitted = true;
    }

    this.checkMechanic("DateChanged")
    this.disableButton=false;
  }
  public getLocalData() {
    this.customerVehicleList =
      this.commonService.getLocalStorage("vehicleData");
    const pkkdt = this.commonService.formatDate(
      new Date(this.customerVehicleList.PKKDate)
    );
    this.pkkDate = pkkdt;

    this.MthsFromRegistration = this.commonService.getLocalStorageByKey(
      "vehicleData",
      "MthsFromRegistration"
    );
    this.DateLastService = this.commonService.getLocalStorageByKey(
      "vehicleData",
      "DateLastService"
    );
    if (
      this.DateLastService != "" &&
      this.DateLastService != undefined &&
      this.DateLastService != null
    ) {
      this.DateLastService = this.commonService.formatDate(
        new Date(this.DateLastService)
      );
    }
    this.BrandCode = this.commonService.getLocalStorageByKey(
      "vehicleData",
      "BrandName"
    );
    this.PackageData = this.commonService.getLocalStorage(
      "PackageServiceListData"
    );
    this.serviceList = this.commonService.getLocalStorage("SelectedService");
   
    this.selectedAccessories = this.commonService.getLocalStorage('SelectedAccessories');
    this.euServiceData =
      this.commonService.getLocalStorage("SelectedEUService");
    this.dealerConfig = this.commonService.getLocalStorage("dealerConfig");
    if (this.dealerConfig.ConfigurationWaitingTimes.length == 0) {
      this.IsCustomerWait = true;
    }
    this.vehicleKilometer = this.commonService.getLocalStorageitem("VehileKm");
    this.ModelImage = this.commonService.getLocalStorageByKey(
      "vehicleData",
      "ModelImage"
    );
    if (this.commonService.getLocalStorage("SelectedEUService")) {
      this.PkkService = true;
    }
    //debugger;
    if (this.serviceList != null) {
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.serviceList.length; i++) {
        this.serviceTotal =
          this.serviceTotal + (!this.commonService.isFreeService(this.BrandCode, this.serviceList[i].groupId) ? this.serviceList[i].LineAmountVat : 0);
      }
    }
    if (this.PackageData != null) {
      this.serviceTotal = Number(
        (this.serviceTotal + this.PackageData.TotalPrice).toFixed(2)
      );
    }
    if (this.euServiceData != null) {
      for (let i = 0; i < this.euServiceData.length; i++) {
        this.serviceTotal =
          this.serviceTotal + this.euServiceData[i].LineAmountVat;
      }
    }
    if(this.selectedAccessories != null && this.selectedAccessories != undefined){
      this.selectedAccessories.forEach(element => {
        this.serviceTotal += element.Price;
      });
    }
   
    this.CustomerNotes = this.commonService.getLocalStorageitem("notes");
    if(this.CustomerNotes==undefined){
      this.CustomerNotes="";
    }
    this.selectedGiftCards = this.commonService.getLocalStorage("selectedGiftCards");
  }
  getRentalcar() {
    this.rentalCarPrice = 0;
    this.rentalCarList = this.commonService.getLocalStorage("RentalCar");
    if (this.rentalCarList == undefined || this.rentalCarList == null) {
      this.totalSelectedRental = false;
    } else {
      this.totalSelectedRental = true;
      this.rentalCarPrice = this.rentalCarList.Price;
    }
  }
  getCSSDynamic() {
    return this.commonService.getBrandTheme(this.BrandCode.toLocaleLowerCase());    
  }
  ngOnInit() {
    this.SelectedDealerName = this.commonService.getLocalStorageitem("SelectedDealerName");
    this.isMinBilUser = this.commonService.getLocalStorageitem("IsMinBilUser") === "true";
    if(!this.isMinBilUser){
      this.getMinBilConsnet();
    }else{
      this.minBilConsent.CampaignConsent = true;
    }
    this.ModelImage =
      "data:image/jpeg;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
    this.brandName = this.commonService.getLocalStorageByKey(
      "vehicleData",
      "BrandName"
    );
    this.getLocalData();
    var dates = this.commonService.getLocalStorage("AvailableDates");
    if (dates == null || dates.length == 0) {
      this.commonService.getErrorMessage("LoaderText.Notavailable");
    }
    this.dealerConfig = this.commonService.getLocalStorage("dealerConfig");
    // let drTime = [];
    // drTime.push({ WaitingTimeSloatId: 0, DealerConfigurationId: 1, TimeSloat: "07:00" })
    // for (let p = 0; p < this.dealerConfig.ConfigurationArrivalTimes.length; p++) {
    //   drTime.push(this.dealerConfig.ConfigurationArrivalTimes[p])
    // }
    // this.dealerConfig.ConfigurationArrivalTimes = drTime

    // let waitTime = [];
    // waitTime.push({ WaitingTimeSloatId: 0, DealerConfigurationId: 1, TimeSloat: "07:00" })
    // for (let p = 0; p < this.dealerConfig.ConfigurationWaitingTimes.length; p++) {
    //   waitTime.push(this.dealerConfig.ConfigurationWaitingTimes[p])
    // }
    // this.dealerConfig.ConfigurationWaitingTimes = waitTime

    this.calculateDuration();
    if (this.commonService.getLocalStorageitem("kiosk")) {
      this.kiosk =
        this.commonService.getLocalStorageitem("kiosk") == "true"
          ? true
          : false;
    }
    if (this.commonService.getLocalStorageitem("PickAtKiosk")) {
      this.PickAtKiosk =
        this.commonService.getLocalStorageitem("PickAtKiosk") == "true"
          ? true
          : false;
    }
    if (this.commonService.getLocalStorageitem("PickUpCar")) {
      this.PickUpCar =
        this.commonService.getLocalStorageitem("PickUpCar") == "true"
          ? true
          : false;
    }
    if (this.commonService.getLocalStorageitem("DeliverCar")) {
      this.DeliverCar =
        this.commonService.getLocalStorageitem("DeliverCar") == "true"
          ? true
          : false;
    }
    if (this.commonService.getLocalStorageitem("waitingTime")) {
      this.CustomerWaitingYes = true;
      this.CuatomerWaitingNo = false;
      this.CustomerWaitings = true;
      this.selectedItems =
        this.commonService.getLocalStorageitem("waitingTime");
    }

    if (this.commonService.getLocalStorageitem("dropTime")) {
      this.CuatomerWaitingNo = true;
      this.CustomerWaitingYes = false;
      this.CustomerWaitingSelected = true;
      this.ShowCar = true;
      this.selectedItem = this.commonService.getLocalStorageitem("dropTime");

      // if (this.commonService.getLocalStorageitem('RentalCar')) {
      //   this.showRentalCar = true;
      //   this.rentalYes = true;
      //   this.rentalNo = false;
      // }
      // else {
      //   this.showRentalCar = false;
      //   this.rentalYes = false;
      //   this.rentalNo = true;
      // }
      if (this.dealerConfig.EnableRentalCar == true) {
        this.showRentalCar = true;
      } else {
        this.showRentalCar = true;
      }
    }
  }

  public calculateDuration() {
    if (Number(this.commonService.getLocalStorageitem("totalTime")) > 0) {
      const duration = this.commonService
        .getLocalStorageitem("totalTime")
        .split(".");
      if (Number(duration[0]) !== 0 || Number(duration[1]) !== 0) {
        if (
          (Number(duration[0]) == 0 && Number(duration[1]) <= 60) ||
          (Number(duration[0]) == 1 && Number(duration[1]) === 0)
        ) {
          this.loadDefaultValues("d");
          //this.IsCustomerWait = false;
        } else {
          this.loadDefaultValues("d");
          // this.notSlected('customerWaiting');
          //this.IsCustomerWait = true;
        }
      } else {
        //this.IsCustomerWait = true;
        // this.notSlected('customerWaiting');
      }
    }
  }

  public loadDefaultValues(type) {
    if (type == "d") {
      this.notSlected("customerWaiting");
      if (!this.commonService.getLocalStorageitem("dropTime")) {
        this.Slected(
          "DropTime",
          this.dealerConfig.ConfigurationArrivalTimes[0].TimeSloat
        );
      }
    } else {
      // this.notSlected('customerWaiting')
      this.Slected(
        "Waiting",
        this.dealerConfig.ConfigurationWaitingTimes[0].TimeSloat
      );
    }
  }

  public checkMechanic(from = "") {
    this.disableButton=true;
    const appointmentDate = this.commonService.getLocalStorage("AppointDate");
    const appointmentCheckAvailabilityRequest: any = [];

  appointmentCheckAvailabilityRequest.totalServicesHours =
      this.commonService.getLocalStorageitem("totalTime");
 
  
    appointmentCheckAvailabilityRequest.brandCode =
      this.commonService.getLocalStorageByKey("vehicleData", "BrandName");
    appointmentCheckAvailabilityRequest.dealerId =
      this.commonService.getLocalStorage("dealername");
    appointmentCheckAvailabilityRequest.PkkService = this.PkkService;
    appointmentCheckAvailabilityRequest.startDate =
      appointmentDate.year +
      "-" +
      appointmentDate.month +
      "-" +
      appointmentDate.day;
    appointmentCheckAvailabilityRequest.IsOnlinePlanner = true;
    if (
      localStorage.getItem("waitingTime") != undefined &&
      localStorage.getItem("waitingTime") != null &&
      localStorage.getItem("waitingTime") != "" && from==''
    ) {
      appointmentCheckAvailabilityRequest["WaitTimeDropTime"] =
        localStorage.getItem("waitingTime");
    } else if (
      localStorage.getItem("dropTime") != undefined &&
      localStorage.getItem("dropTime") != null &&
      localStorage.getItem("dropTime") != "" && from==''
    ) {
      appointmentCheckAvailabilityRequest["WaitTimeDropTime"] =
        localStorage.getItem("dropTime");
    }

    // if(this.selectedSlot!='' && this.selectedSlot!=undefined && this.selectedSlot!=null)
    // {
    //   appointmentCheckAvailabilityRequest["WaitTimeDropTime"] =this.selectedSlot
    // }

    this.translate.get("LoaderText.loading").subscribe((message) => {
      this.loaderservice.show(message);
    });
    if(!this.dealerConfig.IsAFXDealer || appointmentCheckAvailabilityRequest.totalServicesHours < this.splitHours){
      this.dataCommunicationService
      .getAvailableMechanic(appointmentCheckAvailabilityRequest)
      .subscribe(
        (result) => {
          this.loaderservice.hide();
          
          
          if (result != null) {
            if (result.Dates != null && result.Dates.length > 0 && result.Dates[0].Mechanics.length > 0) 
            {
              this.commonService.clearToaster();
              if (from == "") 
              { 
                if(!this.isMinBilUser){
                  this.updateMinBilConsent();
                }else{
                  this.confirmBooking();
                }
                
                
              } 
              else 
              {
                this.availableTimeSlots=result.Timelsots
                if(this.availableTimeSlots!=null && this.availableTimeSlots.length>0 && this.dealerConfig.RealTimeBooking )
                {
                  this.selectedSlot=this.availableTimeSlots[0]
                  this.Slected('DropTime',this.selectedSlot)
                }
                else if(!this.dealerConfig.RealTimeBooking){   
                  this.Slected('DropTime',this.dealerConfig.ConfigurationArrivalTimes[0].TimeSloat);
                }else{
                  this.selectedSlot=null;
                  this.Slected('DropTime',null);
                }
              }
            } 
            else 
            {
              this.availableTimeSlots=[]
              this.commonService.getErrorMessage(
                "LoaderText.MechanicNotAvailable"
              );
              this.disableButton=true;
              this.selectedItem=null
            }

            // this.commonService.NavigatePage(paths.CONFIRMORDER);
          }
          if (this.rentalCarListComponent != undefined && from!="")
            this.rentalCarListComponent.getRentalCars(this.rentalCarDate);
        },
        (error) => {
          this.commonService.getErrorMessage("LoaderText.DMSDown");
          this.SelectedDate = undefined;
          this.selectedItem = undefined;
          this.isServerLive = false;
          this.disableButton=false;
        }
      );

    }
    else{
      
       this.dataCommunicationService
      .getAvailableSplitMechanic(appointmentCheckAvailabilityRequest)
      .subscribe(
        (result) => {
          this.loaderservice.hide();
          
          
          if (result != null) {
            if (result.Dates != null && result.Dates.length > 0 && result.Dates[0].Mechanics.length > 0 && result.Timelsots != null && result.Timelsots.length > 0) 
            {
              this.commonService.clearToaster();
              if (from == "") 
              { 
                if(!this.isMinBilUser){
                  this.updateMinBilConsent();
                }else{
                  this.confirmBooking();
                }
                
                
              } 
              else 
              {
                this.selectedSplitSlot = [];
              // this.availableTimeSlots=result.Timelsots
                var slots = result.Timelsots;
              // Sort by StartDate if needed (optional if already sorted)
              slots.sort((a, b) => new Date(a.StartDate).getTime() - new Date(b.StartDate).getTime());
                this.selectedSplitSlot = slots;
              // Extract first StartDate and format to "HH:mm"
              const firstTime = new Date(slots[0].StartDate)
                .toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
                this.availableTimeSlots = [firstTime];
                if(this.availableTimeSlots!=null && this.availableTimeSlots.length>0 && this.dealerConfig.RealTimeBooking )
                {
                  this.selectedSlot=this.availableTimeSlots[0]
                  this.Slected('DropTime',this.selectedSlot)
                }
                else if(!this.dealerConfig.RealTimeBooking){   
                  this.Slected('DropTime',this.dealerConfig.ConfigurationArrivalTimes[0].TimeSloat);
                }else{
                  this.selectedSlot=null;
                  this.Slected('DropTime',null);
                }
              }
            } 
            else 
            {
              this.availableTimeSlots=[]
              this.commonService.getErrorMessage(
                "LoaderText.MechanicNotAvailable"
              );
              this.disableButton=true;
              this.selectedItem=null
            }

            // this.commonService.NavigatePage(paths.CONFIRMORDER);
          }
          if (this.rentalCarListComponent != undefined && from!="")
            this.rentalCarListComponent.getRentalCars(this.rentalCarDate);
        },
        (error) => {
          this.commonService.getErrorMessage("LoaderText.DMSDown");
          this.SelectedDate = undefined;
          this.selectedItem = undefined;
          this.isServerLive = false;
          this.disableButton=false;
        }
      );
      
    }
  }


  public getMinBilConsnet(){
    this.translate.get("LoaderText.loading").subscribe((message) => {
      this.loaderservice.show(message);
    });
    let phone = this.commonService.getLocalStorageByKey('customerData', 'MobileNo');
    this.dataCommunicationService.GetMinBilConsent(phone).subscribe((resp) =>{
      this.loaderservice.hide();
      if(resp.StatusCode === 1 && resp.Data != null){
        this.minBilConsent = resp.Data;
      }else{
        this.isMinBilUser = true;
        this.minBilConsent.CampaignConsent = true;
      }
    },
    (error)=>{
      this.isMinBilUser = true;
      this.minBilConsent.CampaignConsent = true;
    })
  }

  public updateMinBilConsent(){
    this.translate.get("LoaderText.loading").subscribe((message) => {
      this.loaderservice.show(message);
    });
    this.dataCommunicationService.UpdateMinBilConsent(this.minBilConsent).subscribe(resp=>{
      this.loaderservice.hide();
      if(resp){
        this.confirmBooking();
      }
    })
  }

  public disableDropTimeSlot(t) {
    // var shiftTime = this.dealerConfig.ShiftStartTime.split(':')[0] + '.' + this.dealerConfig.ShiftStartTime.split(':')[1];
    // if (t != shiftTime) {
    //   // let d = moment.duration(t.diff(shiftTime));
    //   var serviceDuration = Number(this.commonService.getLocalStorageitem('totalTime')) + Number(t.replace(':', '.'))
    //   var shiftTime1 = (Number(shiftTime) + 9.30)
    //   if (parseFloat(serviceDuration + '.00') > Number(shiftTime1)) { return 'disableDropTime'; }
    //   else {
    //     if (this.selectedItem == t) {
    //       return 'active'
    //     }
    //   }
    // }
    if (this.selectedItem == t) {
      return "active";
    }

    //return 'active'
  }
}
